export const pageMixin = {
	data() {
		return {
			canClick: true,
		}
	},
	mounted() {},
	methods: {
		collectArticle(article) {
			let apiName = article.ifUpvote ? 'deleteUpvote' : 'postUpvote'
			let params = {
				articleId: article.articleId
			}
			console.log(`--api ${apiName}--参数`);
			console.log(params);
			this.$http[`${apiName}`](params).then((res) => {
				console.log(`--api ${apiName}--结果`);
				console.log(res);
				if (res && res.code === 0) {
					article.ifUpvote = 1 - article.ifUpvote;
					article.ifUpvote ? article.upvoteNum++ : article.upvoteNum--;
				} else {
					if (res.code == -10) {
						this.$message.error('请登录');
					} else {
						this.$message.error(`${res.msg?res.msg:(article.ifUpvote ? '取消点赞失败' : '点赞失败')}`);
					}
				}
			}).finally(() => {});
		},
		fontSize(px) {
			var cw = document.documentElement.clientWidth;
			if (cw < 1920) {
				cw = 1920;
			}
			// else if (cw > 1919 && (cw*1.0/ch).toFixed(2)>1.78) {
			//   cw = ch*1.0/9*16;
			// }
			var fz = (cw * 1.0 / 1920).toFixed(2);
			return fz * px;
		},
		clickFilter(done) {
			if (this.canClick) {
				this.canClick = false;
				setTimeout(() => {
					this.canClick = true;
				}, 800)
				done();
			} else {
				console.log("请勿连续点击!");
			}
		},
		goOutPage: function(url) {
			this.clickFilter(() => {
				window.location.href = url;
			})
		}
	}
}